import { combineReducers } from "redux";
import commonOnePlatFormReducer from "@frameworks/web/redux/reducers/common/commonReducer";
import { CONSOLIDATED_DETAILS, } from "@frameworks/web/redux/interfaces/Reports/iFamilyTagging";
const ConsolidatedDetailsReducer = (state, action) => {
    switch (action.type) {
        case CONSOLIDATED_DETAILS:
            return Object.assign(Object.assign({}, state), { consolidatedDetails: action.payload.consolidatedDetails });
        default:
            return Object.assign({}, state);
    }
};
export default combineReducers({
    reducersData: ConsolidatedDetailsReducer,
    commonData: commonOnePlatFormReducer,
});
